import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ErrorHandling } from "../../utility/ErrorHandling";
import { useNavigate } from "react-router-dom";

export function QueryClientProviderConfig({ children }) {
  const navigate = useNavigate();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0,
        retry: false, // Desabilita retry - se falhar, para
        onError: (error: any) => {
          ErrorHandling(error, navigate);
        },
        // useErrorBoundary(error: any, query) {
        //   if (error?.response?.status != 422) {
        //     return true;
        //   }
        //   return false;
        // },
      },
      mutations: {
        retry: false, // Desabilita retry - se falhar, para
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
    </QueryClientProvider>
  );
}
